/**
 * Monapix Keep Keep
 * Boostrap all necessary files and produce final
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

/* Bootstrap App */
import '~/bootstrap'
/* Services */
import '~/services'
/* Components */
import '~/components'

/**
 * Create the App and initialize Vuew
 */
import App from '~/App.vue'
import Vue from 'vue'

const app = new Vue({
    el: '#app',

    data: {
        address: ''
    },

    methods: {
        /**
        * When the location found
        * @param {Object} addressData Data of the found location
        * @param {Object} placeResultData PlaceResult object
        * @param {String} id Input container ID
        */
        getAddressData: function getAddressData(addressData, placeResultData, id) {
            this.address = addressData;
            console.log(addressData, placeResultData, id)
        },
        handleError: function handleError(error) {
            console.log(error)
        }
    }
});



// WEBPACK FOOTER //
// ./resources/js/app.js